import React from 'react'
import CustomInvCreate from '../invoice/CustomInvCreate'

const CustomCreateInvoice = () => {
  return (
    <div><CustomInvCreate/></div>
  )
}

export default CustomCreateInvoice